import React from 'react';


const ProfessionalBanner = () => {
    return (
        <>
            <div className="profession-banner general-cleaning-sec-row text-center position-relative">

                {/* <div className="general-cleaning-content">
                    <h4> Professional Cleaning</h4>
                    <p>Post Reno, Spring Cleaning, Airon, Upholstery and more</p>
                </div> */}
                    <img src="/assets/images/GenForm-Bannerr_720by190..png" alt="" />
                {/* <div className="general-img1"> */}
                {/* </div> */}
                {/* <div className="general-img2">
                    <img src="/assets/images/im6.png" alt="" />
                </div> */}
            </div>
        </>
    );
};




export default ProfessionalBanner;
